import React from 'react';
import styles from './_section-divider.module.scss';

function SectionsDivider() {
    return <div className={styles.sections_divider} />;
}

export default SectionsDivider;